const rejectRequestedCase = async ({ token, docId, reason, downloadLink }) => {
  const download = downloadLink ? `&download_link_c=${downloadLink}` : "";

  try {
    const response = await fetch(
      `https://lvdmsup.nablasol.net/DMS/api/reject_dms_document?status=Reject&docId=${docId}&reason=${reason}${download}`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    return error;
  }
};

export default rejectRequestedCase;
